import React from 'react';
import { useTranslation } from 'react-i18next';
import type { StockStatus } from '../productManagement';

interface ProductStockBadgeProps {
  status: StockStatus;
}

const STATUS_CLASSES: Record<StockStatus, string> = {
  in: 'bg-success-container text-on-success-container',
  low: 'bg-rating-container text-rating',
  out: 'bg-error-container text-on-error-container',
};

const STATUS_DOT_CLASSES: Record<StockStatus, string> = {
  in: 'bg-success',
  low: 'bg-rating',
  out: 'bg-error',
};

const ProductStockBadge: React.FC<ProductStockBadgeProps> = ({ status }) => {
  const { t } = useTranslation();

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold ${STATUS_CLASSES[status]}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${STATUS_DOT_CLASSES[status]}`} />
      {t(`admin.products.stock.${status}`)}
    </span>
  );
};

export default ProductStockBadge;
